import getIn from '@shopee/get-in';
import { REDUCER_NAME } from './constants';
import { defaultTheme } from 'src/styles/themes';
export const getTheme = (state) => getIn(state, [REDUCER_NAME, 'theme'], defaultTheme);
